<template>

  <div class="production-order-list">

    <div class="po-list-header">

      <h2 class="po-list-title">Danh sách lệnh sản xuất</h2>
      <router-link
        v-if="checkPermission('PRODUCTION_ORDER_CREATE')"
        :to="{ name: 'production-order' }"
        > <b-button
          class="po-list-create-btn"
          size="sm"
          > <i class="mdi mdi-plus"></i> Tạo lệnh sản xuất </b-button
        > </router-link
      >
    </div>
     <!-- Summary cards -->
    <div class="po-summary">

      <div class="po-summary-card">

        <div class="po-summary-icon po-summary-icon--neutral">
           <i class="mdi mdi-file-document-outline"></i>
        </div>

        <div>

          <div class="po-summary-label">TỔNG PHIẾU</div>

          <div class="po-summary-value">{{ summary.totalSlip }}</div>

        </div>

      </div>

      <div class="po-summary-card">

        <div class="po-summary-icon po-summary-icon--export">
           <i class="mdi mdi-arrow-top-right"></i>
        </div>

        <div>

          <div class="po-summary-label">PHIẾU XUẤT</div>

          <div class="po-summary-value">{{ summary.exportCount }}</div>

        </div>

      </div>

      <div class="po-summary-card">

        <div class="po-summary-icon po-summary-icon--import">
           <i class="mdi mdi-arrow-bottom-left"></i>
        </div>

        <div>

          <div class="po-summary-label">PHIẾU NHẬP</div>

          <div class="po-summary-value">{{ summary.importCount }}</div>

        </div>

      </div>

      <div class="po-summary-card">

        <div class="po-summary-icon po-summary-icon--qty"><i class="mdi mdi-cellphone"></i></div>

        <div>

          <div class="po-summary-label">TỔNG SL SẢN PHẨM</div>

          <div class="po-summary-value">{{ summary.totalQuantity }}</div>

        </div>

      </div>

    </div>
     <!-- Filter bar -->
    <div class="po-filter-card">

      <div class="po-filter-field">
         <label>KHOẢNG NGÀY</label>
        <div class="po-filter-daterange">
           <input
            type="date"
            class="po-input"
            v-model="filters.fromDate"
            @change="onFilter"
          /> <span class="po-filter-dash">–</span> <input
            type="date"
            class="po-input"
            v-model="filters.toDate"
            @change="onFilter"
          />
        </div>

      </div>

      <div class="po-filter-field po-filter-field--store">
         <label>KHO</label> <BDropdownCustom
          v-model="valueStore"
          :options="storeOptionsList"
          :placeholder="'kho'"
          :matchKey="['name', 'shortName']"
          :searchable="true"
        />
      </div>

      <div class="po-filter-field">
         <label>LOẠI PHIẾU</label> <b-form-select
          class="select-style"
          size="sm"
          v-model="filters.kind"
          :options="kindOptions"
          value-field="id"
          text-field="name"
          @change="onFilter"
        />
      </div>

      <div class="po-filter-field">
         <label>CHIỀU</label> <b-form-select
          class="select-style"
          size="sm"
          v-model="filters.direction"
          :options="directionOptions"
          value-field="id"
          text-field="name"
          @change="onFilter"
        />
      </div>

      <div class="po-filter-field po-filter-field--grow">
         <label>TÌM MÃ PHIẾU</label>
        <div class="po-search-wrap">
           <i class="mdi mdi-magnify"></i> <input
            type="text"
            class="po-input"
            placeholder="VD: XKCM-1782"
            v-model="filters.searchId"
            @keyup.enter="onFilter"
          />
        </div>

      </div>
       <button
        type="button"
        class="po-clear-btn"
        @click="onClear"
      >
         <i class="mdi mdi-close"></i> Xóa </button
      >
    </div>
     <!-- Table -->
    <div class="po-table-card">

      <table class="po-table po-table--grouped">

        <thead>

          <tr>

            <th style="width: 4%">#</th>

            <th style="width: 17%">MÃ PHIẾU</th>

            <th style="width: 14%">LOẠI PHIẾU</th>

            <th style="width: 8%">KHO</th>

            <th style="width: 36%">SẢN PHẨM &amp; IMEI</th>

            <th
              style="width: 11%"
              class="text-right"
            >
               TỔNG TIỀN
            </th>

            <th style="width: 10%">NGƯỜI TẠO</th>

          </tr>

        </thead>

        <tbody>

          <tr v-if="onLoading">

            <td
              colspan="7"
              class="text-center text-muted py-5"
            >
               <b-spinner small /> Đang tải...
            </td>

          </tr>

          <tr v-else-if="!stockSlips.length">

            <td
              colspan="7"
              class="text-center text-muted py-5"
            >
               Không có phiếu lệnh sản xuất nào.
            </td>

          </tr>
           <template v-for="group in groupedSlips"
            >
            <tr
              :key="`group-${group.linkCode}`"
              class="po-group-head"
            >

              <td colspan="7">
                 <i class="mdi mdi-link-variant"></i> Cặp phiếu Xuất – Nhập · mã liên kết <span
                  class="po-group-code"
                  >{{ group.linkCode }}</span
                >
              </td>

            </tr>

            <tr
              v-for="row in group.rows"
              :key="row.id"
            >

              <td>{{ row.count }}</td>

              <td>
                 <a
                  href="javascript:void(0)"
                  class="po-code-link"
                  @click="openDetail(row)"
                  >{{ row.code }}</a
                >
                <div class="po-code-time">{{ formatDateTime(row.createdAt) }}</div>

                <div
                  v-if="row.description"
                  class="po-code-note"
                >
                   "{{ row.description }}"
                </div>

              </td>

              <td>
                 <span
                  class="po-type-badge"
                  :class="row.isImport ? 'po-type-badge--import' : 'po-type-badge--export'"
                  > <i :class="row.isImport ? 'fas fa-arrow-down' : 'fas fa-arrow-up'"></i> {{
                    row.typeName
                  }} </span
                >
              </td>

              <td>
                 <span class="po-kho"
                  ><i class="mdi mdi-warehouse"></i> {{ row.sourceWarehouseId || '—' }}</span
                >
              </td>

              <td>

                <div class="po-products">

                  <div
                    v-for="(product, pIndex) in row.products"
                    :key="pIndex"
                    class="po-product"
                  >
                     <ProductImage
                      :src="product.productImageUrl"
                      class="po-product-img"
                    />
                    <div class="po-product-info">

                      <div class="po-product-name">
                         {{ product.productName }} <span class="po-product-code"
                          >({{ product.productCode }})</span
                        > <span class="po-product-qty"
                          >SL: <b>{{ product.quantity }}</b></span
                        >
                      </div>

                      <div
                        v-if="product.imeis && product.imeis.length"
                        class="po-imei-list"
                      >
                         <span
                          v-for="(imei, iIndex) in product.imeis"
                          :key="iIndex"
                          class="po-imei-chip"
                          > <i class="mdi mdi-barcode"></i> {{ imei }} </span
                        >
                      </div>

                    </div>

                  </div>

                  <div class="po-products-foot">
                     {{ row.countProduct }} sản phẩm · Tổng SL <b>{{ row.countQuantity }}</b
                    >
                  </div>

                </div>

              </td>

              <td class="text-right font-weight-medium">{{ convertPrice(row.totalAmount) }}</td>

              <td>

                <div class="po-creator">{{ row.createBy }}</div>

                <div class="po-creator-date">{{ formatDate(row.createdAt) }}</div>

              </td>

            </tr>
             </template
          >
        </tbody>

      </table>

      <div class="po-table-foot">
         <span
          >Tổng: <strong>{{ totalItems }}</strong
          > phiếu</span
        > <b-pagination
          v-if="totalPages > 1"
          v-model="page"
          :total-rows="totalItems"
          :per-page="limit"
          align="right"
          size="sm"
          pills
          class="po-list-pagination mb-0"
          @input="fetchList"
        ></b-pagination
        >
      </div>

    </div>
     <ProductionOrderDetailModal
      :visible.sync="showDetail"
      :slip="selectedSlip"
    />
  </div>

</template>

<script>
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import permissionMixin from '@/view/mixins/permission.mixin'
  import ApiService from '@/core/services/api.service'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import moment from 'moment'
  import debounce from 'debounce'
  import { convertPrice } from '@/utils/common'
  import { STOCK_SLIP_TYPE } from '@/utils/enum'
  import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'
  import ProductImage from '@/view/components/products/ProductImage.vue'
  import ProductionOrderDetailModal from './components/ProductionOrderDetailModal.vue'

  const IMPORT_TYPES = [
    STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_PRODUCT,
    STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_IMEI,
  ]
  const TYPE_NAME = {
    [STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_PRODUCT]: 'Nhập kho đổi mã SP',
    [STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_PRODUCT]: 'Xuất kho đổi mã SP',
    [STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_IMEI]: 'Nhập kho đổi IMEI',
    [STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_IMEI]: 'Xuất kho đổi IMEI',
  }

  export default {
    name: 'ProductionOrderList',
    mixins: [apiCommonMixin, permissionMixin],
    components: { BDropdownCustom, ProductImage, ProductionOrderDetailModal },
    data() {
      return {
        filters: {
          fromDate: '',
          toDate: '',
          kind: 0,
          direction: 0,
          searchId: '',
        },
        valueStore: [],
        storeOptionsList: [],
        kindOptions: [
          { id: 0, name: 'Tất cả loại' },
          { id: 1, name: 'Đổi mã sản phẩm' },
          { id: 2, name: 'Đổi IMEI' },
        ],
        directionOptions: [
          { id: 0, name: 'Nhập & Xuất' },
          { id: 1, name: 'Nhập kho' },
          { id: 2, name: 'Xuất kho' },
        ],
        onLoading: false,
        stockSlips: [],
        page: 1,
        limit: 10,
        totalPages: 1,
        totalItems: 0,
        summary: { totalSlip: 0, exportCount: 0, importCount: 0, totalQuantity: 0 },
        showDetail: false,
        selectedSlip: null,
      }
    },
    computed: {
      // Gom các phiếu cùng `linkCode` (số đuôi của mã phiếu) thành nhóm "Cặp phiếu
      // Xuất – Nhập". Giữ thứ tự xuất hiện từ API; cặp Nhập/Xuất luôn liền kề nhau
      // vì được tạo cùng thời điểm (sắp xếp theo createdAt ở backend).
      groupedSlips() {
        if (this.onLoading) return []
        const groups = []
        const indexByCode = {}
        this.stockSlips.forEach((row) => {
          const key = row.linkCode || row.code
          if (indexByCode[key] === undefined) {
            indexByCode[key] = groups.length
            groups.push({ linkCode: key, rows: [] })
          }
          groups[indexByCode[key]].rows.push(row)
        })
        return groups
      },
    },
    methods: {
      convertPrice,
      formatDateTime(value) {
        return value ? moment(value).format('HH:mm DD/MM/YYYY') : ''
      },
      formatDate(value) {
        return value ? moment(value).format('DD/MM/YYYY') : ''
      },
      kindImportTypes() {
        if (this.filters.kind === 1) return [STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_PRODUCT]
        if (this.filters.kind === 2) return [STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_IMEI]
        return [STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_PRODUCT, STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_IMEI]
      },
      kindExportTypes() {
        if (this.filters.kind === 1) return [STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_PRODUCT]
        if (this.filters.kind === 2) return [STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_IMEI]
        return [STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_PRODUCT, STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_IMEI]
      },
      tableTypes() {
        if (this.filters.direction === 1) return this.kindImportTypes()
        if (this.filters.direction === 2) return this.kindExportTypes()
        return [...this.kindImportTypes(), ...this.kindExportTypes()]
      },
      baseParams() {
        return {
          storeIds: this.valueStore.map(({ code }) => code),
          searchCode: this.filters.searchId,
          fromDate: this.filters.fromDate ? `${this.filters.fromDate} 00:00:00` : '',
          toDate: this.filters.toDate ? `${this.filters.toDate} 23:59:59` : '',
        }
      },
      onFilter() {
        this.page = 1
        this.fetchList()
        this.fetchSummary()
      },
      onClear() {
        this.filters = {
          fromDate: '',
          toDate: '',
          kind: 0,
          direction: 0,
          searchId: '',
        }
        this.valueStore = []
        this.onFilter()
      },
      openDetail(row) {
        this.selectedSlip = row
        this.showDetail = true
      },
      fetchList() {
        this.onLoading = true
        const params = {
          page: this.page,
          limit: this.limit,
          types: this.tableTypes(),
          ...this.baseParams(),
        }
        ApiService.query('v1/stock-slips/production-orders', { params })
          .then((response) => {
            const payload = response.data.data
            this.totalPages = payload.totalPage
            this.totalItems = payload.totalRow
            this.stockSlips = (payload.data || []).map((item, index) => ({
              ...item,
              count: (this.page - 1) * this.limit + index + 1,
              isImport: IMPORT_TYPES.includes(item.type),
              typeName: TYPE_NAME[item.type] || '',
              products: item.products || [],
            }))
          })
          .catch((error) => {
            const message = error?.response?.data?.message || 'Không tải được danh sách'
            this.$bvToast.toast(message, { title: 'Thông báo', variant: 'danger', solid: true })
            this.stockSlips = []
          })
          .finally(() => {
            this.onLoading = false
          })
      },
      async fetchSummary() {
        const base = this.baseParams()
        try {
          const [importRes, exportRes, summaryRes] = await Promise.all([
            ApiService.query('v1/stock-slips', {
              params: { page: 1, limit: 1, types: this.kindImportTypes(), ...base },
            }),
            ApiService.query('v1/stock-slips', {
              params: { page: 1, limit: 1, types: this.kindExportTypes(), ...base },
            }),
            ApiService.query('v1/stock-slips/summary', {
              params: { types: [...this.kindImportTypes(), ...this.kindExportTypes()], ...base },
            }),
          ])
          const importCount = importRes.data.data.totalRow || 0
          const exportCount = exportRes.data.data.totalRow || 0
          const summaryData = summaryRes.data.data || {}
          this.summary = {
            importCount,
            exportCount,
            totalSlip: importCount + exportCount,
            totalQuantity: summaryData.totalQuantity || 0,
          }
        } catch (error) {
          this.summary = { totalSlip: 0, exportCount: 0, importCount: 0, totalQuantity: 0 }
        }
      },
    },
    watch: {
      valueStore() {
        // BDropdownCustom emit mỗi lần tích/bỏ tích — gom lại để tránh gọi API liên tục.
        this.debouncedStoreFilter()
      },
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Kho hàng' }, { title: 'Lệnh sản xuất' }])
    },
    async created() {
      this.debouncedStoreFilter = debounce(this.onFilter, 400)
      const { stores } = await this.fetchStoreByUser()
      this.storeOptionsList = stores.map((store) => ({
        code: store.id,
        name: store.name,
        shortName: store.shortName,
        checked: false,
      }))
      this.fetchList()
      this.fetchSummary()
    },
  }
</script>

<style lang="scss">
  @import './production-order-list.scss';
</style>

